import React from "react";

import "./successContainer.scss";

// contact attendees message confirm modal
export default function SuccessContainer({ children }) {
  return (
    <div className="modal-body-heading success d-flex-column justify-content-center align-items-center gap-4">
      {children}
    </div>
  );
}
